import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik, FormikHelpers } from 'formik';

import Button from 'components/UI/Buttons/Button/Button';
import FormikTextRow from 'components/Common/Formik/Row/FormikTextRow';
import { useApiErrors } from 'components/Common/Formik/hooks/useApiErrors';
import Loading from 'components/Common/Loading/Loading';
import { cartContext } from 'contexts/cartContext';
import PrivilegeCodeValidationSchema from 'schemas/PrivilegeCodeValidationSchema';

import styles from './PrivilegeCodeForm.module.scss';

export default function PrivilegeCodeForm(): JSX.Element {
  const { t } = useTranslation(['translation']);
  const {
    setPrivilegeCode,
    validatePrivilegeCode,
    cartPrivilegeMessage,
  } = useContext(cartContext);
  const { setApiErrors, clearApiErrors } = useApiErrors<typeof params>();
  const [isLoading, setIsLoading] = useState(false);
  const params = { privilegeCode: '' };

  function renderCartPrivilegeMessage(): JSX.Element {
    if (!cartPrivilegeMessage.length) {
      return <></>;
    }

    return (
      <div className={styles.cartPrivilegeMessage}>
        <ErrorOutlineIcon />
        <p>{cartPrivilegeMessage}</p>
      </div>
    );
  }

  async function onSubmit(
    values: typeof params,
    actions: FormikHelpers<typeof params>
  ) {
    clearApiErrors(actions);
    setIsLoading(true);
    const { privilegeCode } = values;
    const formattedCode = privilegeCode.toUpperCase();
    const { valid_code, message } = await validatePrivilegeCode(privilegeCode);
    setIsLoading(false);

    if (!valid_code) {
      setApiErrors(actions, {
        privilegeCode: message.length
          ? message.join()
          : t('PRIVILEGE_CODE_ERROR'),
      });
      return;
    }

    setPrivilegeCode(formattedCode);
    actions.resetForm();
  }

  return (
    <>
      <Formik
        initialValues={params}
        onSubmit={onSubmit}
        validationSchema={PrivilegeCodeValidationSchema(t)}
        validateOnChange={false}
        validateOnBlur={false}
      >
        <Form noValidate>
          <FormikTextRow
            classes={{
              closeIcon: styles.inputCloseIcon,
              input: styles.input,
              label: styles.label,
            }}
            inputProps={{
              name: 'privilegeCode',
            }}
            label={t('MY_PRIVILEGE_CODE')}
            message={renderCartPrivilegeMessage()}
          >
            <Button type={'submit'} className={styles.submit}>
              {t('LABEL_CONFIRM')}
            </Button>
          </FormikTextRow>
        </Form>
      </Formik>
      {isLoading && <Loading loading />}
    </>
  );
}
